function getAccessToken() {
  return localStorage.getItem('token')
}

export interface HttpResponse {
  httpStatusCode: number
  json: any
}

const wait = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const validateExistingToken = async () => {
  const accessToken = getAccessToken()
  if (accessToken) return true
  const uniqueVisitId = localStorage.getItem('visit-id')!
  const requestedTokenId = localStorage.getItem(`requested-token`)
  const isAlreadyRequestedToken = requestedTokenId === uniqueVisitId
  if (!isAlreadyRequestedToken) {
    console.log('sent request token at', new Date().toISOString())
    localStorage.setItem(`requested-token`, uniqueVisitId?.toString())
    localStorage.setItem('requested-new-token-at', new Date().getTime().toString())
    window.parent.postMessage('request-new-token', '*')
  }
  while(accessToken === localStorage.getItem('token')) {
    await wait(50)
  }
  return true
}

const isTokenError = async (response: HttpResponse) => {
  try {
    if (response.httpStatusCode === 401 && response.json?.error.error_detail[0].reasons === 'Unauthorized') {
      const accessToken = getAccessToken()
      window.parent.postMessage('request-new-token', '*')
      while(accessToken === localStorage.getItem('token')) {
        await wait(50)
      }
      return true
    }
  } catch (error) {
    console.error('Error checking token error:', error)
  }
  return false
}

export const get = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }

  options.method = 'GET'
  options.signal = controller.signal
  options.headers = { ...options.headers, Authorization: getAccessToken()! }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }

    if (await isTokenError(responseObject)) {
      responseObject = await get(url, options)
    }
    return responseObject
  } catch (e) {
    throw e
  }
}

export const post = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }

  options.method = 'POST'
  options.signal = controller.signal
  options.headers = { ...options.headers, Authorization: getAccessToken()! }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }

    if (await isTokenError(responseObject)) {
      responseObject = await get(url, options)
    }

    return responseObject
  } catch (e) {
    throw e
  }
}

export const del = async (url: string, options?: RequestInit): Promise<HttpResponse | undefined> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }
  options.method = 'DELETE'
  options.signal = controller.signal
  options.headers = { ...options.headers, Authorization: getAccessToken()! }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }

    if (await isTokenError(responseObject)) {
      responseObject = await get(url, options)
    }

    return responseObject
  } catch (e) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}

export const patch = async (url: string, options?: RequestInit): Promise<HttpResponse> => {
  if (!(await validateExistingToken())) {
    return {
      httpStatusCode: 401,
      json: {},
    }
  }
  const controller = new AbortController()

  if (!options) {
    options = { headers: { Authorization: '' } }
  }
  options.method = 'PATCH'
  options.signal = controller.signal
  options.headers = { ...options.headers, Authorization: getAccessToken()! }

  try {
    const response = await fetch(url, options)
    const json = await response.json()

    let responseObject = {
      httpStatusCode: response.status,
      json,
    }

    if (await isTokenError(responseObject)) {
      responseObject = await get(url, options)
    }

    return responseObject
  } catch (e) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
